import { useCallback, useEffect, useReducer } from "react";
export var KeyCodes;
(function (KeyCodes) {
    KeyCodes[KeyCodes["ArrowDown"] = 40] = "ArrowDown";
    KeyCodes[KeyCodes["ArrowUp"] = 38] = "ArrowUp";
    KeyCodes[KeyCodes["Digit0"] = 48] = "Digit0";
    KeyCodes[KeyCodes["Digit9"] = 57] = "Digit9";
    KeyCodes[KeyCodes["End"] = 35] = "End";
    KeyCodes[KeyCodes["Enter"] = 13] = "Enter";
    KeyCodes[KeyCodes["Escape"] = 27] = "Escape";
    KeyCodes[KeyCodes["Home"] = 36] = "Home";
    KeyCodes[KeyCodes["LetterA"] = 65] = "LetterA";
    KeyCodes[KeyCodes["LetterZ"] = 90] = "LetterZ";
    KeyCodes[KeyCodes["Space"] = 32] = "Space";
    KeyCodes[KeyCodes["Tab"] = 9] = "Tab";
})(KeyCodes || (KeyCodes = {}));
export function reducer({ current, labels }, action) {
    const index = current ? labels.indexOf(current) : null;
    const state = (index) => ({ current: labels[(labels.length + index) % labels.length], labels });
    switch (action.type) {
        case "next": {
            return state(index === null ? 0 : index + 1);
        }
        case "previous": {
            return state(index === null ? -1 : index - 1);
        }
        case "first": {
            return state(0);
        }
        case "last": {
            return state(-1);
        }
        case "set-labels": {
            return { current, labels: action.labels };
        }
        case "set": {
            return { current: action.current || null, labels: action.labels };
        }
    }
}
export function useKeyboardNavigation(labels, onAction, preventSpaces = true) {
    const [{ current }, dispatch] = useReducer(reducer, { current: null, labels });
    useEffect(() => {
        dispatch({ type: "set-labels", labels });
    }, [labels]);
    const handleKeyDown = useCallback((event) => {
        switch (event.key) {
            case "ArrowDown": {
                event.preventDefault();
                return dispatch({ type: "next" });
            }
            case "ArrowUp": {
                event.preventDefault();
                return dispatch({ type: "previous" });
            }
            case "Home": {
                event.preventDefault();
                return dispatch({ type: "first" });
            }
            case "End": {
                event.preventDefault();
                return dispatch({ type: "last" });
            }
            case " ": {
                if (!preventSpaces) {
                    return;
                }
            }
            // eslint-disable-next-line no-fallthrough
            case "Enter": {
                event.preventDefault();
                return onAction("toggle", current, event);
            }
            case "Escape": {
                event.preventDefault();
                return onAction("close", current, event);
            }
        }
        return onAction("type", String.fromCodePoint(event.keyCode), event);
    }, [current, onAction, preventSpaces]);
    const setPreselection = useCallback((current) => {
        if (current !== null)
            dispatch({ type: "set", current, labels });
    }, [labels]);
    return {
        current,
        handleKeyDown,
        setPreselection,
    };
}
export default useKeyboardNavigation;
//# sourceMappingURL=use-keyboard-navigation.js.map